import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-cream min-h-screen">
      <Navbar />

      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-20 pb-12">
        <div className="text-[11px] uppercase tracking-[0.32em] text-ink-soft mb-4">Journal</div>
        <h1 className="font-serif text-5xl md:text-6xl text-ink leading-[1.05]">Reflections, resources & gentle reminders.</h1>
        <p className="text-ink-muted text-lg md:text-xl max-w-2xl mt-6 leading-relaxed">
          Short reads from Jesse on faith, mental health, growth, and walking through life&apos;s harder seasons.
        </p>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pb-24">
        {loading ? (
          <div className="py-20 flex items-center justify-center text-ink-soft">
            <Loader2 className="animate-spin mr-2" /> Loading…
          </div>
        ) : posts.length === 0 ? (
          <div className="py-20 text-center text-ink-soft italic font-serif text-lg border border-dashed border-sand rounded-3xl">
            New writing is on its way. Check back soon.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-8" data-testid="blog-grid">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group block bg-cream-soft border border-sand/70 rounded-3xl overflow-hidden hover:border-navy/40 transition-colors"
              >
                {p.cover_image_path && (
                  <div className="aspect-[16/9] bg-sand/40 overflow-hidden">
                    <img
                      src={`${API}/blog-cover/${p.id}`}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="p-7 md:p-8">
                  <div className="text-[11px] uppercase tracking-[0.22em] text-ink-soft mb-3">
                    {formatDate(p.published_at)}
                  </div>
                  <h2 className="font-serif text-2xl text-ink leading-tight group-hover:text-navy transition-colors">{p.title}</h2>
                  {p.excerpt && <p className="text-ink-muted mt-3 leading-relaxed">{p.excerpt}</p>}
                  <div className="inline-flex items-center gap-1.5 text-navy text-sm mt-5 group-hover:gap-3 transition-all">
                    Read <ArrowRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}
